import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { TempOverviewData } from '../hooks';

interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  row: TempOverviewData | null;
  isDeleting?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  row,
  isDeleting = false,
}) => {
  const fileName = row?.fileName || 'Unknown File';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-testid="delete-confirmation-modal"
    >
      <DialogTitle data-testid="delete-modal-title">
        Confirm Deletion
      </DialogTitle>
      
      <DialogContent data-testid="delete-modal-content">
        <Box sx={{ py: 2 }}>
          <Typography variant="body1">
            Are you sure you want to delete <strong>{fileName}</strong>?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          disabled={isDeleting}
          data-testid="delete-modal-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isDeleting}
          data-testid="delete-modal-confirm-btn"
        >
          {isDeleting ? 'Deleting...' : 'Yes, Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
